export const ADMIN_REQUEST_TYPE = {
  LICENSE: 1
};
